import { FC } from 'react'

import BroadcastsFilters from 'component/Broadcasts/BroadcastsFilters'
import styles from './styles.module.scss'

const BroadcastsHeader: FC = () => {
	return (
		<header className={styles.broadcastsHeader}>
			<div className={styles.broadcastsHeader_title}>
				<h3>Broadcasts</h3>
			</div>
			<div className={styles.broadcastsHeader_actions}>
				<BroadcastsFilters />
			</div>
		</header>
	)
}

export default BroadcastsHeader
